import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Quote from "@/pages/Quote";
import ServicesPage from "@/pages/Services";
import Navbar from "@/components/Navbar";
import CallFab from "@/components/CallFab";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.15 });
    window.__lenis = lenis;
    return () => lenis.destroy();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-white text-ink">
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/services" element={<ServicesPage />} />
        </Routes>
        <CallFab />
        <Toaster position="bottom-center" />
      </div>
    </BrowserRouter>
  );
}

export default App;
